/* eslint-disable no-unused-vars */
import React, { useRef, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import themeSettings from '../../../commons/styles/themeSettings.json';
import {
  StyledBox,
  StyledBoxLabel
} from './CSS/style';
import {
  getList,
  getDeployHistory,
  //getStatusList,
  getUserList,
  SubmitForm,
  FormSubmission,
  FormUpdation
} from '../APICalls/FormCalls';
import Highlighter from 'react-highlight-words';
import {
  RBSLOOKUPMaster,
  MASTERDATASOURCE,
  ANALYTICS,
  DRIFT,
  MASTERALGORITHM,
  ServerRegistrationMasters,
  RBSPREDMODEL,
  IPAddress
} from '../../../commons/api';
import {
  Tabs,
  Form,
  Input,
  Select,
  Button,
  DatePicker,
  Space,
  message,
  Collapse,
  Tooltip,
  Modal
} from 'antd';
import StyledTable from '../../../commons/styles/table';
import localStorage from '../../../utils/localStorage';
import { Link, useNavigate } from 'react-router-dom';
import { Breadcrumb } from 'antd';
import axios from 'axios';
import moment from 'moment';
import dayjs from 'dayjs';
import {
  PlusOutlined,
  UserOutlined,
  FieldTimeOutlined,
  MinusCircleOutlined,
  SearchOutlined
} from '@ant-design/icons';
const { Option } = Select;
const { RangePicker } = DatePicker;

const APIList = {
  getList: `${ANALYTICS.UseCaseGet}`,
  PredictionGet: `${ANALYTICS.PredictionGetById}`,
  getMetrics: `${RBSLOOKUPMaster.LookUpItemsGetById}`,
  getDataSourceList: `${MASTERDATASOURCE.DatasourceList}`,
  CreateTrainingJob: `${ANALYTICS.TrainingJobCreate}`,
  Get: `${ANALYTICS.TrainingJobGet}`,
  GetById: `${ANALYTICS.TrainingJobGetById}`,
  getDeviceList: `${DRIFT.GetDevice}`,
  getParameterList: `${DRIFT.DriftParameters}`,
  getAlgorithmList: `${MASTERALGORITHM.GET}`,
  getTrainingServerList: `${ServerRegistrationMasters.GET}`,
  ModelWorkBenchListGet: `${RBSPREDMODEL.ModelWorkBenchList}`,
  Parameterslist: `${ANALYTICS.Parameterslist}`,
  UpdateTrainingJob: `${ANALYTICS.TrainningJobUpdate}`,
  GitPush: `${IPAddress.PREDICTIONIP}/training/gitpush`
};
const Operator = [
  {
    key: 'EqualTo (==)',
    value: '=='
  },
  {
    key: 'Not EqualTo (!=)',
    value: '!='
  },
  {
    key: 'Greater Than (>)',
    value: '>'
  },
  {
    key: 'Less Than (<)',
    value: '<'
  },
  {
    key: 'Greater Than Or EqualTo (>=)',
    value: '>='
  },
  {
    key: 'Less Than Or EqualTo (<=)',
    value: '<='
  }
];

const OPTIONS = ['0', '1'];
// const dayjs = require('dayjs')
const utc = require('dayjs/plugin/utc');
dayjs.extend(utc);


const TrainingJobs = (props) => {
  const [formObject, setFormObject] = useState({});
  const [pagination, setPagnition] = useState([]);
  //const [dataSource, setDataSource] = useState([]);
  const [type, setType] = useState([]);
  const [modelsDataSource, setModelsDataSource] = useState([]);
  // const [id, setId] = useState([]);
  const [modelTypeList, setModelTypeList] = useState([]);
  const [trainingServerList, setTrainingServerList] = useState([]);
  const [selectedModelType, setSelectedModelType] = useState('');
  const [lagUnitList, setLagUnitList] = useState([]);
  //const [statusList, setStatusList] = useState([]);
  const [futurePeriodUomList, setFuturePeriodUomList] = useState([]);
  const [dataSourceList, setDataSourceList] = useState([]);
  const [applicableMetricsList, setApplicableMetricsList] = useState([]);
  const [deviceList, setDeviceList] = useState([]);
  const [tagsData, setTagsData] = useState([]);
  const [parameterList, setParameterList] = useState([]);
  const [parametersData, setParametersData] = useState([]);
  const [filterParameterList, setFilterParameterList] = useState([]);
  const [hyperParametersData, setHyperParametersData] = useState([]);
  const [aggregationParameterList, setAggregationParameterList] = useState([]);
  const [filters, setFilters] = useState([]);
  const [transformationParameterList, setTransformationParameterList] = useState([]);
  const [aggregations, setAggregations] = useState([]);
  // const [classificationParameterList, setClassificationParameterList] = useState([]);
  const [payload, setPayload] = useState({});
  const [transformations, setTransformations] = useState([]);
  const [parameterModal, setParameterModal] = useState(false);
  const [users, setUsers] = useState([]);
  const [labelParameterList, setLabelParameterList] = useState([]);
  const [breadcrumbList, setBreadcrumbList] = useState([]);
  const [classification, setClassification] = useState({});
  const [algorithmList, setAlgorithmList] = useState([]);
  //const [isActive] = useState(true);
  const [momentRange3, setMomentRange3] = useState([]);
  // const [selectedFilterValue, setSelectedFilterValue] = useState(null);
  const [momentRange2, setMomentRange2] = useState([]);
  //const [selectedClassificationValue, setSelectedClassificationValue] = useState(null);
  const [momentRange1, setMomentRange1] = useState([]);
  // const [selectedLagValue, setSelectedLagValue] = useState(null);
  const [searchText, setSearchText] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [searchedColumn, setSearchedColumn] = useState([]);
  const [translationCache, setTranslationCache] = useState(props.translationCache || {});
  // const [range, setRange] = useState([]);
  const [userProfile, setUserProfile] = useState(props.userProfile || {});
  // const [test_ToTime, setTest_ToTime] = useState([]);
  const [taskId, setTaskId] = useState(null);
  const [analyticsId, setAnalyticsId] = useState(null);
  // const [path,setPath] = useState([]);
  const searchInputRef = useRef(null);
   let [FiltersRef] = Form.useForm();
   let [AggregationsRef] = Form.useForm();
   let [TransformationsRef] = Form.useForm();
   let [ClassificationRef] = Form.useForm();
   let [dynamicFormRef] = Form.useForm();
   let [mainFormRef] = Form.useForm();

  const navigate = useNavigate();

  // let isActive = true;
  useEffect(() => {
    getTrainingJobInitialData();
  }, []);

  useEffect(() => {
    if (props.userProfile !== userProfile || props.translationCache !== translationCache) {
      setUserProfile(props.userProfile);
      setTranslationCache(props.translationCache);
    }
    if (props.location !== location) {
      getTrainingJobInitialData();
    }
  }, [props.userProfile, props.translationCache, props.location]);

  const getTrainingJobInitialData = async () => {
    let searchParams = new URLSearchParams(props.location.search);
    let newParams = Object.fromEntries([...searchParams]);
    let taskId = newParams && newParams.TaskId;
    setTaskId(taskId);

    const pathSnippets = props.location.pathname.split(`/rubus/RubusAnalytics/TrainningJob/`).filter((i) => i);
    if (pathSnippets && pathSnippets[0]) {
      let useCaseLevel = pathSnippets[0].split('/').filter((i) => i);
      if (useCaseLevel && useCaseLevel[useCaseLevel.length - 1] !== 'New') {
        let payload = {
          //AnalyticsId: analyticsId,
          TaskId: taskId,
          Id: useCaseLevel && useCaseLevel[useCaseLevel.length - 1]
        };
        let formObject = await SubmitForm(payload, APIList.GetById);
        if (formObject) {
          let TagsList = [];
          Object.values(formObject?.DataSet?.[0]?.Tags || []).forEach((key) => {
            if (Array.isArray(key)) {
              TagsList.push(...key);
            }
          });
          mainFormRef?.setFieldsValue({
            Name: formObject?.Name,
            Description: formObject?.Description,
            Status: formObject?.Status,
            TrainingServerId: formObject?.TrainingServerId,
            CreatedBy: formObject?.CreatedBy,
            CreatedDate: dayjs(formObject.CreatedDate).format('YYYY-MM-DD HH:mm:ss'),
            Id: formObject?.Id,
            DataSourceID: formObject?.DataSet?.[0]?.DataSourceId,
            Devices: formObject?.DataSet?.[0]?.Devices,
            Tags: TagsList,
            AlgorithmId: formObject?.AlgorithmData?.[0]?.AlgorithmId,
            ModelType: formObject?.AlgorithmData?.[0]?.ModelType,
            HyperParameters: formObject?.AlgorithmData?.[0]?.HyperParameters,
            Metrics: formObject?.AlgorithmData?.[0]?.Metrics,
            TargetDevices: formObject?.LabellingData?.[0]?.Devices,
            TargetParameter: formObject?.LabellingData?.[0]?.TargetTag,
            Aggregation: formObject?.LabellingData?.[0]?.Aggregation,
            FuturePeriodFrom: formObject?.LabellingData?.[0]?.FuturePeriodFrom,
            FuturePeriodTo: formObject?.LabellingData?.[0]?.FuturePeriodTo,
            FuturePeriodUom: 'MINUTES',
            TestDate: [
              dayjs(formObject?.DataSet?.[0]?.Test_FromTime),
              dayjs(formObject?.DataSet?.[0]?.test_ToTime)
            ],

            TrainDate: [
              dayjs(formObject?.DataSet?.[0]?.Training_FromTime),
              dayjs(formObject?.DataSet?.[0]?.Training_ToTime)
            ],

            ValidationDate: [
              dayjs(formObject?.DataSet?.[0]?.Validation_FromTime),
              dayjs(formObject?.DataSet?.[0]?.Validation_ToTime)
            ]

          });

          let ModelType = formObject?.AlgorithmData?.[0]?.ModelType;
          let applicableMetricsList = ModelType === 'Regression'

            ? await getDeployHistory(APIList.getMetrics, 'LookupName', 'RBS_MODEL_REG_METRICS')
            : await getDeployHistory(APIList.getMetrics, 'LookupName', 'RBS_MODEL_CLF_METRICS');


          let futurePeriodUomList = await getDeployHistory(APIList.getMetrics, 'LookupName', 'UOM');

          let lagUnitList = await getDeployHistory(APIList.getMetrics, 'LookupName', 'LAG_UNITS');

          let modelsDataSource = formObject?.ModelDetails || [];

          setBreadcrumbList(formObject && formObject.Path);
          setModelsDataSource(modelsDataSource);
          setLagUnitList(lagUnitList);
          setFuturePeriodUomList(futurePeriodUomList);
          setApplicableMetricsList(applicableMetricsList);
          setSelectedModelType(ModelType);
          setTagsData(formObject.DataSet?.[0]?.Tags);
          setParametersData({
            users: formObject?.AlgorithmData?.[0]?.HyperParameters
          });

          setHyperParametersData(formObject?.AlgorithmData?.[0]?.HyperParameters);

          dynamicFormRef?.setFieldsValue({
            users: formObject?.AlgorithmData?.[0]?.HyperParameters
          });


          setFilters({
            filters: formObject?.Preprocess?.[0]?.Filters
          });

          setAggregations({
            aggregations: formObject?.Preprocess?.[0]?.Aggregations
          });

          setTransformations({
            transformations: formObject?.Preprocess?.[0]?.Transformations
          });

          setClassification({
            classification: formObject?.LabellingData?.[0]?.Classification
          });


          FiltersRef?.setFieldsValue({
            filters: formObject?.Preprocess?.[0]?.Filters
          });

          AggregationsRef?.setFieldsValue({
            aggregations: formObject?.Preprocess?.[0]?.Aggregations
          });

          TransformationsRef?.setFieldsValue({
            transformations: formObject?.Preprocess?.[0]?.Transformations
          });

          ClassificationRef?.setFieldsValue({
            classification: formObject?.LabellingData?.[0]?.Classification
          });


          let parameterList = {
            DeviceCode: formObject?.DataSet?.[0]?.Devices
          };

          let response = await SubmitForm(parameterList, APIList.Parameterslist);

          setParameterList(response || []);

          let labelParameterList = {
            DeviceCode: [formObject?.LabellingData?.[0]?.Devices]
          };

          let response4 = await SubmitForm(labelParameterList, APIList.Parameterslist);

          setLabelParameterList(response4 || []);

          formObject?.LabellingData?.forEach(async (item) => {

            if (item?.classification) {
              await Promise.all(item.classification.map(async () => {

                // let classificationParameterList = {
                //   DeviceCode: [i.Device]
                // };
                //      let response5 = await SubmitForm(classificationParameterList, APIList.Parameterslist);
                // setClassificationParameterList(response5 || []);
              }));
            }
          });

          formObject?.Preprocess?.forEach(async (item) => {

            if (item?.filters) {
              await Promise.all(item.filters.map(async (i) => {
                let filterParameterList = {
                  DeviceCode: [i.Device]
                };
                let response1 = await SubmitForm(filterParameterList, APIList.Parameterslist);
                setFilterParameterList(response1 || []);
              }));
            }

            if (item?.aggregations) {
              await Promise.all(item.aggregations.map(async (i) => {
                let aggregationParameterList = {
                  DeviceCode: [i.Device]
                };
                let response2 = await SubmitForm(aggregationParameterList, APIList.Parameterslist);
                setAggregationParameterList(response2 || []);
              }));

            }

            if (item?.transformations) {
              await Promise.all(item.transformations.map(async (i) => {
                let transformationParameterList = {
                  DeviceCode: [i.Device]
                };
                let response3 = await SubmitForm(transformationParameterList, APIList.Parameterslist);
                setTransformationParameterList(response3 || []);
              }));
            }
          });
          setFormObject(formObject);

        } else {

          mainFormRef?.setFieldsValue({

            Name: null,
            Description: null,
            Status: null,
            TrainingServerId: null,
            CreatedBy: props.userProfile?.user?.Id,
            CreatedDate: dayjs().format('YYYY-MM-DD HH:mm:ss'),
            Id: null,
            DataSourceID: null,
            Devices: [],
            Tags: [],
            AlgorithmId: null,
            ModelType: null,
            HyperParameters: null,
            Metrics: [],
            TargetDevices: [],
            TargetParameter: [],
            Aggregation: null
          });

          setFormObject({});
          setTagsData([]);
          setFilters({});
          setAggregations({});
          setTransformations({});
          setClassification({});
          setModelsDataSource([]);
          setLabelParameterList([]);
          setParameterList([]);
          setFilterParameterList([]);
          setAggregationParameterList([]);
          setTransformationParameterList([]);
          FiltersRef?.setFieldsValue({
              filters: []
            });
          AggregationsRef?.setFieldsValue({
              aggregations: []
            });
          TransformationsRef?.setFieldsValue({
              transformations: []
            });
          ClassificationRef?.setFieldsValue({
              classification: []
            });
        }

      } else {

        let path = props.location.state?.breadcrumbList;

        let data = [

          {

            title: 'Training Job',
            key: 'TrainningJob',
            type: 'TrainningJob'

          }

        ];

        let PathList = path && path !== undefined && path.concat(data);

        setBreadcrumbList(PathList);

        mainFormRef?.setFieldsValue({
          CreatedBy: props.userProfile?.user?.Id,
          CreatedDate: dayjs().format('YYYY-MM-DD HH:mm:ss')
        });

      }

    }


    let futurePeriodUomList = await getDeployHistory(APIList.getMetrics, 'LookupName', 'UOM');

    let lagUnitList = await getDeployHistory(APIList.getMetrics, 'LookupName', 'LAG_UNITS');

    let modelTypeList = await getDeployHistory(APIList.getMetrics, 'LookupName', 'RBS_PRED_MODEL_TYPES');

    let deviceList = await getList(APIList.getDeviceList);

    let trainingServerList = await getList(APIList.getTrainingServerList);

    let algorithmList = await getList(APIList.getAlgorithmList);

    // let statusList = await getStatusList();

    let dataSourceList = await getList(APIList.getDataSourceList);


    setModelTypeList(modelTypeList);
    setFuturePeriodUomList(futurePeriodUomList);
    setLagUnitList(lagUnitList);
    // setStatusList(statusList);
    setDataSourceList(dataSourceList);
    setTrainingServerList(trainingServerList);
    setDeviceList(deviceList);
    setUsers(await getUserList());
    setAlgorithmList(algorithmList);
  };

  const translation = (keyword) => {
    const { translationCache } = props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };


  const editList = async (Id) => {

    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const object = {

      method: 'GET',
      url: `${APIList.getList}?SiteId=${siteId}&Id=${Id}&Type=Usecase`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };

    try {

      const response = await axios(object);
      return response.data;
    } catch (error) {
      console.error(error);
    }

  };


  const changeOnBreadCrumb = async (breadCrumb, e, index) => {

    const value = [...breadcrumbList];
    const data = value.splice(0, index + 1);
    const dataVal = data[data.length - 1];
    if (dataVal) {
      const Id = dataVal.Id;
      if (dataVal.type === 'usecase' && Id !== undefined) {
        const editData = await editList(Id);
        if (editData) {
          props.navigate(`/rubus/RubusAnalytics/usecase/${dataVal.Id}`);
        }

      }


      if (dataVal.type === 'Prediction' || dataVal.type === 'Analysis') {
        let Id = dataVal && dataVal.Id;

        if (Id !== undefined) {
          const payload = {
            AnalyticsId: data && data[1] && data[1].Id,
            Id: dataVal && dataVal.Id
          };
          const FormData = await SubmitForm(payload, APIList.PredictionGet);

          setAnalyticsId(data[1].Id);
          setType(FormData &&FormData.Type);
          navigate(`/rubus/RubusAnalytics/Tasks/${dataVal.Id}?AnalyticsId=${data[1].Id}&Type=${FormData.Type}`);
        }
      }

    }

  };


  const FormSave = async (e) => {
    e.preventDefault();
    const FormData = mainFormRef?.getFieldsValue();
    const FiltersData = FiltersRef?.getFieldsValue();
    const AggregationData = AggregationsRef?.getFieldsValue();
    const TransformationsData = TransformationsRef?.getFieldsValue();
    const ClassificationData = ClassificationRef?.getFieldsValue();

    let groupedTags = {};

    if (tagsData && typeof tagsData === 'object') {
      groupedTags =
        tagsData &&
        Array.isArray(tagsData) &&
        tagsData.reduce((result, obj) => {
          (result[obj.Device] = result[obj.Device] || []).push(obj.value);
          return result;
        }, {});

    } else {
      groupedTags = props.tagsData;
    }

    try {

      await mainFormRef?.validateFields();

      const payload = {

        Name: FormData.Name,
        Description: FormData.Description,
        Status: FormData.Status,
        TrainingServerId: FormData.TrainingServerId,
        CreatedBy: FormData.CreatedBy,
        CreatedDate: FormData.CreatedDate && moment(FormData.CreatedDate).utc().format('YYYY-MM-DD HH:mm:ss'),
        TaskId: props.taskId,
        DataSet: [

          {

            Id: props.formObject?.DataSet[0]?.Id,
            DataSourceID: FormData.DataSourceID,
            Devices: FormData.Devices,
            Tags: groupedTags,
            Training_FromTime: moment(FormData.TrainDate[0]),
            Training_ToTime: moment(FormData.TrainDate[1]),
            Validation_FromTime: moment(FormData.ValidationDate[0]),
            Validation_ToTime: moment(FormData.ValidationDate[1]),
            Test_FromTime: moment(FormData.TestDate[0]),
            Test_ToTime: moment(FormData.TestDate[1])

          }

        ],

        Preprocess: [

          {
            Id: props.formObject?.Preprocess[0]?.Id,
            Filters: FiltersData.filters || props.filters.filters,
            Aggregations: AggregationData.aggregations || props.aggregations.aggregations,
            Transformations: TransformationsData.transformations || props.transformations.transformations
          }

        ],

        AlgorithmData: [

          {
            Id: props.formObject?.AlgorithmData[0]?.Id,
            AlgorithmId: FormData.AlgorithmId,
            ModelType: FormData.ModelType,
            HyperParameters: props.hyperParametersData,
            Metrics: FormData.Metrics
          }
        ],

        LabellingData: [
          {
            Id: props.formObject?.LabellingData[0]?.Id,
            TargetDevices: FormData.TargetDevices,
            TargetParameter: FormData.TargetParameter,
            Aggregation: FormData.Aggregation,
            FuturePeriodFrom: FormData.FuturePeriodFrom,
            FuturePeriodTo: FormData.FuturePeriodTo,
            FuturePeriodUom: 'MINUTES',
            classification: ClassificationData.Classification || props.Classification.Classification
          }
        ]
      };

      let FiltersArray = payload.Preprocess[0].Filters;
      let msg1 = '';
      let msg11 = '';

      FiltersArray &&
        Array.isArray(FiltersArray) &&
        FiltersArray.length !== 0 &&
        FiltersArray.filter((data) => {
          if (data === null || data === undefined) {
            FiltersRef?.validateFields();
            setPayload({});
            msg1 = 'Please add mandatory fields in Filters';
            message.error('Please add mandatory fields in Filters');
            return false;
          } else {
            msg1 = '';
            return true;
          }
        });
      FiltersArray &&
        Array.isArray(FiltersArray) &&
        FiltersArray.length !== 0 &&
        FiltersArray.forEach((item) => {
          if (item) {
            const values = Object.values(item);
            const shouldFilter = values.filter((value) => {
              return (
                value === undefined ||
                value === null ||
                (value === '' && values.length <= 4) ||
                values.length !== 4
              );
            });
            if (shouldFilter.length > 0) {
              FiltersRef?.validateFields();
              setPayload({});
              message.error('Please add mandatory fields in Filters');
            }
          }
        });

      let AggregationArray = payload.Preprocess[0].Aggregations;
      let msg2 = '';
      let msg21 = '';

      AggregationArray &&
        Array.isArray(AggregationArray) &&
        AggregationArray.length !== 0 &&
        AggregationArray.forEach((item) => {
          if (item && item !== undefined) {
            const valuesArray = Object.values(item);
            const hasMandatoryFields = valuesArray.every((value) => {
              return (
                value !== undefined &&
                value !== null &&
                !(value === '' && valuesArray.length <= 5) &&
                valuesArray.length === 5
              );
            });

            if (!hasMandatoryFields) {
              AggregationsRef?.validateFields();
              setPayload({});
              message.error('Please add mandatory fields in Aggregations');
            }
          }
        });
      if (
        AggregationArray &&
        Array.isArray(AggregationArray) &&
        AggregationArray.length !== 0
      ) {
        const hasInvalidFields = AggregationArray.filter((data, index) => {
          if (
            AggregationArray[index] === null ||
            AggregationArray[index] === undefined ||
            data === null ||
            data === undefined
          ) {
            AggregationsRef?.validateFields();
            setPayload({});
            message.error('Please add mandatory fields in Aggregations');
            return true; // Return true for invalid entries
          }
          return false; // Return false for valid entries
        });

        if (hasInvalidFields.length > 0) {
          msg21 = 'Please add mandatory fields in Aggregations===';
        } else {
          msg21 = '';
        }
      }


      let TransformationArray = payload.Preprocess[0].transformations;
      let msg3 = '';
      let msg31 = '';

      if (
        TransformationArray &&
        Array.isArray(TransformationArray) &&
        TransformationArray.length !== 0
      ) {
        const hasInvalidFields = TransformationArray.filter((data) => {
          if (data === null || data === undefined) {
            TransformationsRef?.validateFields();
            setPayload({});
            message.error('Please add mandatory fields in Transformations');
            return true; // Return true for invalid entries
          }
          return false; // Return false for valid entries
        });

        if (hasInvalidFields.length > 0) {
          msg3 = 'Please add mandatory fields in Transformations';
        } else {
          msg3 = '';
        }
      }

      TransformationArray &&
        Array.isArray(TransformationArray) &&
        TransformationArray.length !== 0 &&
        TransformationArray.forEach((item) => {
          if (item && item !== undefined) {
            const hasInvalidFields = Object.values(item).filter((values) => {
              if (
                values === undefined ||
                values === null ||
                (values === '' && Object.values(item).length <= 3) ||
                Object.values(item).length !== 3
              ) {
                TransformationsRef?.validateFields();
                setPayload({});
                message.error('Please add mandatory fields in Transformations');
                return true;
              }
              return false;
            });
            if (hasInvalidFields.length > 0) {
              msg31 = 'Please add mandatory fields in Transformations';
            } else {
              msg31 = '';
            }
          }
        });

      let msg4 = '';
      let msg41 = '';
      let msg42 = '';

      let ClassificationArray = [];

      if (selectedModelType && selectedModelType === 'Classification') {
        ClassificationArray = payload.LabellingData[0].classification;
        if (
          ClassificationArray === undefined ||
          ClassificationArray === null ||
          (ClassificationArray && ClassificationArray.length === 0)
        ) {
          msg42 = 'Please Add Classification Target';
          message.error('Please Add Classification Target');
          setPayload({});
        } else {
          msg42 = '';
        }

        if (
          ClassificationArray &&
          Array.isArray(ClassificationArray) &&
          ClassificationArray.length !== 0
        ) {
          const hasInvalidFields = ClassificationArray.filter((data) => {
            if (data === null || data === undefined) {
              ClassificationRef?.validateFields();
              setPayload({});
              message.error('Please add mandatory fields in Classification');
              return true; // Return true for invalid entries
            }
            return false; // Return false for valid entries
          });

          if (hasInvalidFields.length > 0) {
            msg4 = 'Please add mandatory fields in Classification';
          } else {
            msg4 = '';
          }
        }

        ClassificationArray &&
          Array.isArray(ClassificationArray) &&
          ClassificationArray.length !== 0 &&
          ClassificationArray.forEach((item) => {
            if (item && item !== undefined) {
              const valuesArray = Object.values(item);
              const hasInvalidFields = valuesArray.filter((values) => {
                // Check for invalid conditions
                if (
                  values === undefined ||
                  values === null ||
                  (values === '' && valuesArray.length <= 4) ||
                  valuesArray.length !== 4
                ) {
                  ClassificationRef?.validateFields();
                  setPayload({});
                  message.error('Please add mandatory fields in Classification');
                  return true; // Return true for invalid entries
                }
                return false; // Return false for valid entries
              });

              msg41 = hasInvalidFields.length > 0 ? 'Please add mandatory fields in Classification' : '';
            }

          });
      }

      if (selectedModelType && selectedModelType === 'Classification') {
        if (
          msg1 === '' &&
          msg11 === '' &&
          msg2 === '' &&
          msg21 === '' &&
          msg3 === '' &&
          msg31 === '' &&
          msg4 === '' &&
          msg41 === '' &&
          msg42 === ''
        ) {
          setPayload(payload);
          message.success('Successfully Saved');
        } else {
          setPayload({});
        }
      } else if (
        selectedModelType &&
        selectedModelType !== 'Classification'
      ) {
        if (
          msg1 === '' &&
          msg11 === '' &&
          msg2 === '' &&
          msg21 === '' &&
          msg3 === '' &&
          msg31 === ''
        ) {
          setPayload(payload);
          message.success('Successfully Saved');
        } else {
          setPayload({});
        }
      } else {
        setPayload({});
        message.error('Please enter Required fields');
      }
    }
    catch (error) {
      setPayload({});
      message.error('Please Provide Required Fields');
      console.log(error);
    }
  };
  const FormSubmit = async () => {

    if (payload) {
      if (formObject && formObject.Id) {
        const updatedPayload = { ...payload, Id: formObject.Id };
        const UpdateResponse = await FormUpdation(updatedPayload, APIList.UpdateTrainingJob);

        if (UpdateResponse && UpdateResponse.status === 200) {
          message.success(UpdateResponse.data.message);
          const PayloadForPrediction = { Id: UpdateResponse.data.Id };
          const PredictionResponse = await FormUpdation(PayloadForPrediction, APIList.GitPush);
          if (PredictionResponse && PredictionResponse.status === 200) {
            message.success(PredictionResponse.data.message);
          }
          const payload = { analyticsId: analyticsId, taskId: taskId, Id: UpdateResponse.data.Id };
          const formObject = await SubmitForm(payload, APIList.GetById);
          const TagsList = [];
          Object.values(formObject?.DataSet?.[0]?.Tags || []).forEach((key) => {
            if (Array.isArray(key)) {

              key.forEach((item) => TagsList.push(item));

            }

          });


          mainFormRef?.setFieldsValue({

            Name: formObject?.Name,
            Description: formObject?.Description,
            Status: formObject?.Status,
            TrainingServerId: formObject?.TrainingServerId,
            CreatedBy: formObject?.CreatedBy,
            CreatedDate: dayjs(formObject.CreatedDate).format('YYYY-MM-DD HH:mm:ss'),
            Id: formObject?.Id,
            DataSourceID: formObject?.DataSet?.[0]?.DataSourceId,
            Devices: formObject?.DataSet?.[0]?.Devices,
            Tags: TagsList,
            AlgorithmId: formObject?.AlgorithmData?.[0]?.AlgorithmId,
            ModelType: formObject?.AlgorithmData?.[0]?.ModelType,
            HyperParameters: hyperParametersData,
            Metrics: formObject?.AlgorithmData?.[0]?.Metrics,
            TargetDevices: formObject?.LabellingData?.[0]?.Devices,
            TargetParameter: formObject?.LabellingData?.[0]?.TargetTag,
            Aggregation: formObject?.LabellingData?.[0]?.Aggregation,
            FuturePeriodFrom: formObject?.LabellingData?.[0]?.FuturePeriodFrom,
            FuturePeriodTo: formObject?.LabellingData?.[0]?.FuturePeriodTo,
            FuturePeriodUom: 'MINUTES',

            TestDate: [
              dayjs(formObject?.DataSet?.[0]?.Test_FromTime),
              dayjs(formObject?.DataSet?.[0]?.Test_ToTime),
            ],

            TrainDate: [
              dayjs(formObject?.DataSet?.[0]?.Training_FromTime),
              dayjs(formObject?.DataSet?.[0]?.Training_ToTime),
            ],

            ValidationDate: [
              dayjs(formObject?.DataSet?.[0]?.Validation_FromTime),
              dayjs(formObject?.DataSet?.[0]?.Validation_ToTime),
            ],

          });


          props.navigate(`/rubus/RubusAnalytics/TrainningJob/${UpdateResponse.data.Id}?TaskId=${taskId}`);


          const ModelType = formObject?.AlgorithmData?.[0]?.ModelType;
          const applicableMetricsList = ModelType === 'Regression'
            ? await getDeployHistory(APIList.getMetrics, 'LookupName', 'RBS_MODEL_REG_METRICS')
            : await getDeployHistory(APIList.getMetrics, 'LookupName', 'RBS_MODEL_CLF_METRICS');


          const futurePeriodUomList = await getDeployHistory(APIList.getMetrics, 'LookupName', 'UOM');
          const lagUnitList = await getDeployHistory(APIList.getMetrics, 'LookupName', 'LAG_UNITS');


          setBreadcrumbList(formObject?.Path);
          // setLastBreadcrumb('TrainningJob');
          setFuturePeriodUomList(futurePeriodUomList);
          setLagUnitList(lagUnitList);
          setApplicableMetricsList(applicableMetricsList);
          setSelectedModelType(ModelType);
          setParametersData({
            users: formObject?.AlgorithmData?.[0]?.HyperParameters,
          });
          setHyperParametersData(formObject?.AlgorithmData?.[0]?.HyperParameters);

          dynamicFormRef?.setFieldsValue({
            users: formObject?.AlgorithmData?.[0]?.HyperParameters,
          });

          const modelsDataSource = formObject?.ModelDetails || [];
          setModelsDataSource(modelsDataSource);
          //  setPath(formObject?.path);
          setFormObject(formObject);
          setFilters({
            filters: formObject?.Preprocess?.[0]?.filters,
          });

          setAggregations({
            aggregations: formObject?.Preprocess?.[0]?.aggregations,
          });

          setTransformations({
            transformations: formObject?.Preprocess?.[0]?.transformations,
          });
          setClassification({
            classification: formObject?.LabellingData?.[0]?.Classification,
          });

          FiltersRef?.setFieldsValue({
            filters: formObject?.Preprocess?.[0]?.filters,
          });

          AggregationsRef?.setFieldsValue({
            aggregations: formObject?.Preprocess?.[0]?.Aggregations,
          });

          TransformationsRef?.setFieldsValue({
            transformations: formObject?.Preprocess?.[0]?.transformations,
          });

          ClassificationRef?.setFieldsValue({
            classification: formObject?.LabellingData?.[0]?.Classification,
          });

          const parameterList = {
            DeviceCode: formObject?.DataSet?.[0]?.Devices,
          };
          const response = await SubmitForm(parameterList, APIList.Parameterslist);
          setParameterList(response || []);

          const labelParameterList = {
            DeviceCode: formObject?.LabellingData?.[0]?.Devices,
          };
          const response4 = await SubmitForm(labelParameterList, APIList.Parameterslist);
          setLabelParameterList(response4 || []);

          formObject?.LabellingData?.forEach((item) => {
            if (item?.classification) {
              item.classification.forEach(async () => {
                //  const classificationParameterList = { DeviceCode: [i.Device] };
                // const response5 = await SubmitForm(classificationParameterList, APIList.Parameterslist);
                //   setClassificationParameterList(response5 || []);
              });
            }
          });

          formObject?.Preprocess?.forEach((item) => {
            if (item?.filters) {
              item.filters.forEach(async (i) => {
                const filterParameterList = { DeviceCode: [i.Device] };
                const response1 = await SubmitForm(filterParameterList, APIList.Parameterslist);
                setFilterParameterList(response1 || []);
              });
            }
            if (item?.aggregations) {
              item.aggregations.forEach(async (i) => {
                const aggregationParameterList = { DeviceCode: [i.Device] };
                const response2 = await SubmitForm(aggregationParameterList, APIList.Parameterslist);
                setAggregationParameterList(response2 || []);
              });
            }
            if (item?.transformations) {
              item.transformations.forEach(async (i) => {
                const transformationParameterList = { DeviceCode: [i.Device] };
                const response3 = await SubmitForm(transformationParameterList, APIList.Parameterslist);
                setTransformationParameterList(response3 || []);
              });
            }
          });
          setFormObject(formObject);
        } else {
          message.error(UpdateResponse.data.message);
        }
      } else {
        const createResponse = await FormSubmission(payload, APIList.CreateTrainingJob);
        if (createResponse && createResponse.status === 200) {
          message.success(createResponse.data.message);
          const PayloadForPrediction = { Id: createResponse.data.Id };
          const PredictionResponse = await FormUpdation(PayloadForPrediction, APIList.GitPush);
          if (PredictionResponse && PredictionResponse.status === 200) {
            message.success(PredictionResponse.data.message);
          }

          const payload = { AnalyticsId: analyticsId, TaskId: taskId, Id: createResponse.data.Id };
          const formObject = await SubmitForm(payload, APIList.GetById);
          const TagsList = [];

          Object.values(formObject &&
            formObject.DataSet &&
            formObject.DataSet[0] &&
            formObject.DataSet[0].Tags || []).forEach((key) => {
              if (Array.isArray(key)) {
                key.forEach((item) => TagsList.push(item));
              }
            });
          mainFormRef?.setFieldsValue({
              Name: formObject && formObject.Name,
              Description: formObject && formObject.Description,
              Status: formObject && formObject.Status,
              TrainingServerId: formObject && formObject.TrainingServerId,
              CreatedBy: formObject && formObject.CreatedBy,
              CreatedDate:
                formObject &&
                formObject.CreatedDate &&
                dayjs(formObject.CreatedDate).format('YYYY-MM-DD HH:mm:ss'),
              Id: formObject && formObject.Id,
              DataSourceID:
                formObject &&
                formObject.DataSet &&
                formObject.DataSet[0] &&
                formObject.DataSet[0].DataSourceId,
              Devices:
                formObject &&
                formObject.DataSet &&
                formObject.DataSet[0] &&
                formObject.DataSet[0].Devices,
              Tags: TagsList,
              AlgorithmId:
                formObject &&
                formObject.AlgorithmData &&
                formObject.AlgorithmData[0] &&
                formObject.AlgorithmData[0].AlgorithmId,
              ModelType:
                formObject &&
                formObject.AlgorithmData &&
                formObject.AlgorithmData[0] &&
                formObject.AlgorithmData[0].ModelType,
              HyperParameters:
                formObject &&
                formObject.AlgorithmData &&
                formObject.AlgorithmData[0] &&
                formObject.AlgorithmData[0].HyperParameters,
              Metrics:
                formObject &&
                formObject.AlgorithmData &&
                formObject.AlgorithmData[0] &&
                formObject.AlgorithmData[0].Metrics,
              TargetDevices:
                formObject &&
                formObject.LabellingData &&
                formObject.LabellingData[0] &&
                formObject.LabellingData[0].Devices,
              TargetParameter:
                formObject &&
                formObject.LabellingData &&
                formObject.LabellingData[0] &&
                formObject.LabellingData[0].TargetTag,
              Aggregation:
                formObject &&
                formObject.LabellingData &&
                formObject.LabellingData[0] &&
                formObject.LabellingData[0].Aggregation,

              FuturePeriodFrom:
                formObject &&
                formObject.LabellingData &&
                formObject.LabellingData[0] &&
                formObject.LabellingData[0].FuturePeriodFrom,

              FuturePeriodTo:
                formObject &&
                formObject.LabellingData &&
                formObject.LabellingData[0] &&
                formObject.LabellingData[0].FuturePeriodTo,

              FuturePeriodUom: 'MINUTES',
              // formObject &&
              // formObject.LabellingData &&
              // formObject.LabellingData[0] &&
              // formObject.LabellingData[0].FuturePeriodUom,

              TestDate: [
                dayjs(
                  formObject &&
                  formObject.DataSet &&
                  formObject.DataSet[0] &&
                  formObject.DataSet[0].Test_FromTime
                ),
                dayjs(
                  formObject &&
                  formObject.DataSet &&
                  formObject.DataSet[0] &&
                  formObject.DataSet[0].Test_ToTime
                )
              ],

              TrainDate: [
                dayjs(
                  formObject &&
                  formObject.DataSet &&
                  formObject.DataSet[0] &&
                  formObject.DataSet[0].Training_FromTime
                ),
                dayjs(
                  formObject &&
                  formObject.DataSet &&
                  formObject.DataSet[0] &&
                  formObject.DataSet[0].Training_ToTime
                )
              ],

              ValidationDate: [
                dayjs(
                  formObject &&
                  formObject.DataSet &&
                  formObject.DataSet[0] &&
                  formObject.DataSet[0].Validation_FromTime
                ),
                dayjs(
                  formObject &&
                  formObject.DataSet &&
                  formObject.DataSet[0] &&
                  formObject.DataSet[0].Validation_ToTime
                )
              ]
              // Attachments:formObject.Attachments
            });
          props.navigate(
            `/rubus/RubusAnalytics/TrainningJob/${createResponse.data.Id}?TaskId=${taskId}`
          );
          const ModelType = formObject?.AlgorithmData?.[0]?.ModelType;
          const applicableMetricsList = ModelType === 'Regression'
            ? await getDeployHistory(APIList.getMetrics, 'LookupName', 'RBS_MODEL_REG_METRICS')
            : await getDeployHistory(APIList.getMetrics, 'LookupName', 'RBS_MODEL_CLF_METRICS');
          const futurePeriodUomList = await getDeployHistory(APIList.getMetrics, 'LookupName', 'UOM');
          const lagUnitList = await getDeployHistory(APIList.getMetrics, 'LookupName', 'LAG_UNITS');

          setBreadcrumbList(formObject && formObject?.Path);
          //setLastBreadcrumb('TrainningJob');
          setFuturePeriodUomList(futurePeriodUomList);
          setLagUnitList(lagUnitList);
          setApplicableMetricsList(applicableMetricsList);
          setSelectedModelType(ModelType);
          setParametersData({
            users: formObject?.AlgorithmData?.[0]?.HyperParameters,
          });
          setHyperParametersData(formObject?.AlgorithmData?.[0]?.HyperParameters);
          dynamicFormRef?.setFieldsValue({
            users: formObject?.AlgorithmData?.[0]?.HyperParameters,
          });

          // setId(formObject.Id),


          //  setPath(formObject?.path);
          setFormObject(formObject);
          setFilters({
            filters:
              formObject &&
              formObject.Preprocess &&
              formObject.Preprocess[0] &&
              formObject.Preprocess[0].Filters
          });
          setAggregations({
            aggregations:
              formObject &&
              formObject.Preprocess &&
              formObject.Preprocess[0] &&
              formObject.Preprocess[0].Aggregations
          });
          setTransformations({
            transformations:
              formObject &&
              formObject.Preprocess &&
              formObject.Preprocess[0] &&
              formObject.Preprocess[0].Transformations
          });
          setClassification({
            classification:
              formObject &&
              formObject.LabellingData &&
              formObject.LabellingData[0] &&
              formObject.LabellingData[0].Classification
          });

          FiltersRef?.setFieldsValue({
            filters: formObject?.Preprocess?.[0]?.filters,
          });

          AggregationsRef?.setFieldsValue({
            aggregations: formObject?.Preprocess?.[0]?.Aggregations,
          });

          TransformationsRef?.setFieldsValue({
            transformations: formObject?.Preprocess?.[0]?.transformations,
          });

          ClassificationRef?.setFieldsValue({
            classification: formObject?.LabellingData?.[0]?.Classification
          });

          const parameterList = {
            DeviceCode:
              formObject &&
              formObject.DataSet &&
              formObject.DataSet[0] &&
              formObject.DataSet[0].Devices
          };

          const response = await SubmitForm(parameterList, APIList.Parameterslist);
          setParameterList(response || []);

          const labelParameterList = {
            DeviceCode: formObject &&
              formObject.LabellingData &&
              formObject.LabellingData[0] && [formObject.LabellingData[0].Devices]
          };
          const response4 = await SubmitForm(labelParameterList, APIList.Parameterslist);
          setLabelParameterList(response4 || []);
          formObject &&
            formObject.LabellingData &&
            Array.isArray(formObject.LabellingData) &&
            formObject?.LabellingData?.forEach((item) => {
              if (item?.Classification) {
                item.Classification.forEach(async () => {
                  //    const classificationParameterList = { DeviceCode: [i.Device] };
                  //   const response5 = await SubmitForm(classificationParameterList, APIList.Parameterslist);
                  //    setClassificationParameterList(response5 || []);
                });
              }
            });
          formObject &&
            formObject.Preprocess &&
            Array.isArray(formObject.Preprocess) &&
            formObject?.Preprocess?.forEach((item) => {
              if (item?.filters) {
                item.filters.forEach(async (i) => {
                  const filterParameterList = { DeviceCode: [i.Device] };
                  const response1 = await SubmitForm(filterParameterList, APIList.Parameterslist);
                  setFilterParameterList(response1 || []);
                });
              }
              if (item?.aggregations) {
                item.aggregations.forEach(async (i) => {
                  const aggregationParameterList = { DeviceCode: [i.Device] };
                  const response2 = await SubmitForm(aggregationParameterList, APIList.Parameterslist);
                  setAggregationParameterList(response2 || []);
                });
              }
              if (item?.transformations) {
                item.transformations.forEach(async (i) => {
                  const transformationParameterList = { DeviceCode: [i.Device] };
                  const response3 = await SubmitForm(transformationParameterList, APIList.Parameterslist);
                  setTransformationParameterList(response3 || []);
                });
              }
            });
          setFormObject(formObject);
        } else {
          message.error(createResponse.data.message);
        }
      }
    } else {
      message.error('Please Save Before Submit');
    }
  };

  const disabledDate = (current) => {
    return current > dayjs().endOf('day');
  };

  const onSubmit = (values) => {
    setHyperParametersData(values?.users);
    setParameterModal(false);
    setParametersData({ users: values.users });
  };

  const onChangeTrainDate = (value, dateString) => {
    if (dateString) {
      //setRange([dateString[0], dateString[1]]);
      setMomentRange1([dayjs(dateString[0]), dayjs(dateString[1])]);
      // setTraining_FromTime(dayjs(dateString[0]));
      // setTraining_ToTime(dayjs(dateString[1]));
    }
  };

  const onChangeValidationDate = (value, dateString) => {
    //setRange([dateString[0], dateString[1]]);
    setMomentRange2([dayjs(dateString[0]), dayjs(dateString[1])]);
    // setValidation_FromTime(dayjs(dateString[0]));
    // setValidation_ToTime(dayjs(dateString[1]));
  };

  const onChangeTestDate = (value, dateString) => {
    // setRange([dateString[0], dateString[1]]);
    setMomentRange3([dayjs(dateString[0]), dayjs(dateString[1])]);
    //  setTest_FromTime(dayjs(dateString[0]));
    //setTest_ToTime(dayjs(dateString[1]));
  };

  // const onChangeTargetDate = (value, dateString) => {
  //   setRange([dateString[0], dateString[1]]);
  //   setMomentRange4([dayjs(dateString[0]), dayjs(dateString[1])]);
  //   setTargetFrom(dayjs(dateString[0]));
  //   setTargetTo(dayjs(dateString[1]));
  // };
  const onModelTypeChange = async (value) => {
    let applicableMetricsList = [];
    if (value === 'Regression') {
      applicableMetricsList = await getDeployHistory(APIList.getMetrics, 'LookupName', 'RBS_MODEL_REG_METRICS');
    } else {
      applicableMetricsList = await getDeployHistory(APIList.getMetrics, 'LookupName', 'RBS_MODEL_CLF_METRICS');
    }
    mainFormRef?.setFieldsValue({ Metrics: [] });
    setApplicableMetricsList(applicableMetricsList);
    setSelectedModelType(value);
    setSelectedItems([]);
  };

  const onCheck = async (key, value) => {
    const parameterList = { DeviceCode: value };
    mainFormRef?.setFieldsValue({ Tags: [] });
    const response = await SubmitForm(parameterList, APIList.Parameterslist);
    setParameterList(response || []);
  };

  const tagChange = (key, value) => {
    setTagsData(value);
  };

  const onDeviceCheck = async (key, value) => {
    const filterParameterList = { DeviceCode: [value] };
    const response = await SubmitForm(filterParameterList, APIList.Parameterslist);
    setFilterParameterList(response || []);
  };

  const onAggregationCheck = async (key, value) => {
    const aggregationParameterList = { DeviceCode: [value] };
    const response = await SubmitForm(aggregationParameterList, APIList.Parameterslist);
    setAggregationParameterList(response || []);
  };

  const onTransformationCheck = async (key, value) => {
    const transformationParameterList = { DeviceCode: [value] };
    const response = await SubmitForm(transformationParameterList, APIList.Parameterslist);
    setTransformationParameterList(response || []);
  };
  // onClassificationCheck = async (key, value) => {
  //   let ClassificationParameterList = {
  //     DeviceCode: [value]
  //   };
  //   let response = await SubmitForm(ClassificationParameterList, APIList.Parameterslist);
  //   this.setState({
  //     ClassificationParameterList: response ? response : []
  //   });
  // };

  const onCheckDevice = async (key, value) => {
    const labelParameterList = { DeviceCode: [value] };
    mainFormRef?.setFieldsValue({ TargetParameter: '' });
    const response = await SubmitForm(labelParameterList, APIList.Parameterslist);
    setLabelParameterList(response || []);
  };
  const algorithmChange = async (value) => {
    const hyperParameterList = await getDeployHistory(APIList.getAlgorithmList, 'Id', value);

    setParametersData({
      users: hyperParameterList && hyperParameterList[0] && hyperParameterList[0].HyperParameters
    });
    setHyperParametersData(hyperParameterList && hyperParameterList[0] && hyperParameterList[0].HyperParameters
    );
    dynamicFormRef?.setFieldsValue({
        users: hyperParameterList && hyperParameterList[0] && hyperParameterList[0].HyperParameters
      });
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input

          ref={searchInputRef}
          placeholder={translation('Search') + translation(dataIndex)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />

        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}

          style={{ width: 90, marginRight: '5px' }}
        >
          {translation('Search')}
        </Button>

        <Button
          onClick={() => clearFilters && handleReset(clearFilters, confirm)}

          style={{ width: 90 }}
        >
          {translation('Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInputRef.current.select());
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      ),
  });

  // const onChangeValue = (value) => {
  //   if (!isNaN(value)) {
  //     setSelectedFilterValue(value);
  //   } else {
  //     message.error('Please Input Numeric Values Only');
  //   }
  // };

  // const onChangeValue1 = (value) => {
  //   if (!isNaN(value)) {
  //     setSelectedClassificationValue(value);
  //   } else {
  //     message.error('Please Input Numeric Values Only');
  //   }
  // };

  // const lagOnChange = (value) => {
  //   if (!isNaN(value)) {
  //     setSelectedLagValue(value);
  //   } else {
  //     message.error('Please Input Numeric Values Only');
  //   }
  // };

  const classOnChange = (selectedItems) => {
    setSelectedItems(selectedItems);
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
    setSearchText('');
  };

  // const onCollapseChange = () => {
  //   if (
  //     (filters && filters.filters) ||
  //     (aggregations && aggregations.aggregations) ||
  //     (transformations && transformations.transformations)
  //   ) {
  //     setOpenPanels(1);
  //   }
  // };


  const filteredOptions = OPTIONS.filter((o) => !selectedItems.includes(o));
  const ModelsColumns = [

    {
      title: translation('Name'),
      dataIndex: 'ModelName',
      key: 'ModelName',
      // Assuming getColumnSearchProps is defined in your component
      ...getColumnSearchProps('ModelName'),
      sorter: (a, b) => a.ModelName.localeCompare(b.ModelName),
    },

    {
      title: translation('Type'),
      dataIndex: 'ModelType',
      key: 'ModelType',
      ...getColumnSearchProps('ModelType'),
      sorter: (a, b) => a.ModelType.localeCompare(b.ModelType),
    },

    {
      title: translation('Group'),
      dataIndex: 'ModelGroup',
      key: 'ModelGroup',
      ...getColumnSearchProps('ModelGroup'),
      sorter: (a, b) => a.ModelGroup.localeCompare(b.ModelGroup),
    },

    {
      title: translation('Created By'),
      key: 'CreatedBy',
      dataIndex: 'CreatedBy',
      ...getColumnSearchProps('CreatedBy'),
      sorter: (a, b) => a.CreatedBy.localeCompare(b.CreatedBy),
    },

    {
      title: translation('Created Date'),
      key: 'CreatedDate',
      dataIndex: 'CreatedDate',
      ...getColumnSearchProps('CreatedDate'),
      sorter: (a, b) => new Date(a.CreatedDate) - new Date(b.CreatedDate),
      render: (text) => (
        text !== undefined && text !== null ? (
          <div>{dayjs(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
        ) : null
      ),
    },

    {
      title: translation('Enabled'),
      dataIndex: 'Enabled',
      key: 'Enabled',
      ...getColumnSearchProps('Enabled'),
      sorter: (a, b) => String(a.Enabled).localeCompare(String(b.Enabled)),
      render: (text) => String(text),
    },
    {
      title: translation('Status'),
      dataIndex: 'Status',
      key: 'Status',
      ...getColumnSearchProps('Status'),
      sorter: (a, b) => a.Status.localeCompare(b.Status),

    },

    {
      title: translation('Action'),
      render: (text, record) => (
        <Tooltip
          title={
            record.Status === 'Deployed' || record.Status === 'Registered'
              ? translation('Open Details')
              : translation('Click to Register')
          }
        >
          <a
            style={{ marginRight: '5px' }}
            onClick={() => props.navigate(`/rubus/RbsAnalytics/ModelDetails/${record.ModelId}`)}
          >
            {record.Status === 'Deployed' || record.Status === 'Registered'
              ? translation('Details')
              : translation('Register')}
          </a>
        </Tooltip>
      ),
    },
  ];
  const formItemLayout = { width: '100%', flex: '50%' };
  console.log(filters,'filteryssh',FiltersRef?.getFieldsValue());
  
  let preprocessingItems = [
      {
        key: '1',
        label: 'Filter Conditions',
        children: (
          <div>
            <Form
              name="dynamic_form_nest_item_Filters"
              // onFinish={this.onFiltersSubmit}
              autoComplete="off"
              form={FiltersRef}
              // initialValues={filters}
              style={{ paddingLeft: '15%' }}
            >
              <Form.List name="Filters">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <Space
                        key={key}
                        style={{
                          display: 'flex',
                          marginBottom: 8
                        }}
                        align="baseline"
                      >
                        <Form.Item
                          {...restField}
                          name={[name, 'Device']}
                          rules={[
                            {
                              required: true,
                              message: 'Missing Device'
                            }
                          ]}
                        >
                          <Select
                            placeholder=" Device"
                            // maxTagCount={1}
                            style={{ width: '200px' }}
                            // mode="multiple"
                            onChange={(value) => onDeviceCheck('Device', value)}
                          >
                            {deviceList &&
                              Array.isArray(deviceList) &&
                              deviceList.map((item, index) => {
                                return (
                                  <Select.Option key={index} value={item.key}>
                                    {item.key}
                                  </Select.Option>
                                );
                              })}
                          </Select>
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, 'Tag']}
                          rules={[
                            {
                              required: true,
                              message: 'Missing Tag'
                            }
                          ]}
                        >
                          <Select
                            placeholder=" Tag"
                            style={{ width: '200px' }}
                            // maxTagCount={'responsive'}
                            // mode="multiple"
                            options={filterParameterList}
                          />
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, 'Condition']}
                          rules={[
                            {
                              required: true,
                              message: 'Missing Condition'
                            }
                          ]}
                        >
                          <Select placeholder=" Condition" style={{ width: '200px' }}>
                            {Operator.map((item, index) => {
                              return (
                                <>
                                  <Select.Option key={index} value={item.value}>
                                    {item.value}
                                  </Select.Option>
                                </>
                              );
                            })}
                          </Select>
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, 'Value']}
                          rules={[
                            {
                              required: true,
                              message: 'Missing Value'
                            }
                          ]}
                        >
                          <Input
                            type="number"
                            onKeyDown={(e) => {
                              if ([8].includes(e.keyCode)) {
                                return;
                              }
                              if (
                                (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
                                (e.keyCode < 96 || e.keyCode > 105)
                              ) {
                                e.preventDefault();
                              }
                            }}
                            placeholder=" Value"
                            style={{ width: '200px' }}
                          // onChange={this.onChangeValue}
                          />
                        </Form.Item>
                        <MinusCircleOutlined onClick={() => remove(name)} />
                      </Space>
                    ))}
                    <Form.Item>
                      <Button
                        type="dashed"
                        style={{ width: '500px' }}
                        onClick={() => add()}
                        block
                        icon={<PlusOutlined />}
                      >
                        Add Filter
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List>
            </Form>
          </div>
        ),
      },
      {
        key: '2',
        label: 'Aggregations',
        children: (
          <div>
            <Form
              name="dynamic_form_nest_item2"
              // onFinish={this.onAggregationsSubmit}
              autoComplete="off"
              form={AggregationsRef}
              initialValues={aggregations}
              style={{ paddingLeft: '15%' }}
            >
              <Form.List name="Aggregations">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <Space
                        key={key}
                        style={{
                          display: 'flex',
                          marginBottom: 8
                        }}
                        align="baseline"
                      >
                        <Form.Item
                          {...restField}
                          name={[name, 'Device']}
                          rules={[
                            {
                              required: true,
                              message: 'Missing Device'
                            }
                          ]}
                        >
                          <Select
                            placeholder=" Device"
                            // maxTagCount={1}
                            style={{ width: '200px' }}
                            // mode="multiple"
                            onChange={(value) =>
                              onAggregationCheck('Device', value)
                            }
                          >
                            {deviceList &&
                              Array.isArray(deviceList) &&
                              deviceList.map((item, index) => {
                                return (
                                  <Select.Option key={index} value={item.key}>
                                    {item.key}
                                  </Select.Option>
                                );
                              })}
                          </Select>
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, 'Tag']}
                          rules={[
                            {
                              required: true,
                              message: 'Missing Tag'
                            }
                          ]}
                        >
                          <Select
                            placeholder=" Tag"
                            style={{ width: '200px' }}
                            // maxTagCount={'responsive'}
                            // mode="multiple"
                            options={aggregationParameterList}
                          />
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, 'Method']}
                          rules={[
                            {
                              required: true,
                              message: 'Missing Method'
                            }
                          ]}
                        >
                          <Select placeholder="Method" style={{ width: '200px' }}>
                            <Select.Option value="Min">Min</Select.Option>
                            <Select.Option value="Max">Max</Select.Option>
                            <Select.Option value="Sum"> Sum</Select.Option>
                            <Select.Option value="Mean"> Mean</Select.Option>
                            <Select.Option value="Avarage"> Average</Select.Option>
                          </Select>
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, 'lag']}
                          rules={[
                            {
                              required: true,
                              message: 'Missing lag'
                            }
                          ]}
                        >
                          <Input type="number"
                            onKeyDown={(e) => {
                              if ([8].includes(e.keyCode)) {
                                return;
                              }
                              if (
                                (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
                                (e.keyCode < 96 || e.keyCode > 105)
                              ) {
                                e.preventDefault();
                              }
                            }}
                            style={{ width: '200px' }}
                            placeholder="lag"
                          />
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, 'lag unit']}
                          rules={[
                            {
                              required: true,
                              message: 'Missing lag unit'
                            }
                          ]}
                        >
                          <Select placeholder="lag unit" style={{ width: '200px' }}>
                            {lagUnitList &&
                              Array.isArray(lagUnitList) &&
                              lagUnitList.map((item) => {
                                return (
                                  <Select.Option value={item.key} key={item.key}>
                                    {item.key}
                                  </Select.Option>
                                );
                              })}{' '}
                          </Select>
                        </Form.Item>
                        <MinusCircleOutlined onClick={() => remove(name)} />
                      </Space>
                    ))}
                    <Form.Item>
                      <Button
                        type="dashed"
                        style={{ width: '500px' }}
                        onClick={() => add()}
                        block
                        icon={<PlusOutlined />}
                      >
                        Add Aggregations
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List>
            </Form>
          </div>
        ),
      },
      {
        key: '3',
        label: 'Transformations',
        children: (
          <div>
            <Form
              name="dynamic_form_nest_item3"
              // onFinish={this.onTransformationsSubmit}
              autoComplete="off"
              form={TransformationsRef}
              initialValues={transformations}
              style={{ paddingLeft: '15%' }}
            >
              <Form.List name="Transformations">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <Space
                        key={key}
                        style={{
                          display: 'flex',
                          marginBottom: 8
                        }}
                        align="baseline"
                      >
                        <Form.Item
                          {...restField}
                          name={[name, 'Device']}
                          rules={[
                            {
                              required: true,
                              message: 'Missing Device'
                            }
                          ]}
                        >
                          <Select
                            placeholder=" Device"
                            // maxTagCount={1}
                            style={{ width: '200px' }}
                            // mode="multiple"
                            onChange={(value) =>
                              onTransformationCheck('Device', value)
                            }
                          >
                            {deviceList &&
                              Array.isArray(deviceList) &&
                              deviceList.map((item, index) => {
                                return (
                                  <Select.Option key={index} value={item.key}>
                                    {item.key}
                                  </Select.Option>
                                );
                              })}
                          </Select>
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, 'Tag']}
                          rules={[
                            {
                              required: true,
                              message: 'Missing Tag'
                            }
                          ]}
                        >
                          <Select
                            placeholder=" Tag"
                            style={{ width: '200px' }}
                            // maxTagCount="responsive"
                            // mode="multiple"
                            options={transformationParameterList}
                          />
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, 'Method']}
                          rules={[
                            {
                              required: true,
                              message: 'Missing Method'
                            }
                          ]}
                        >
                          <Select placeholder="Method" style={{ width: '200px' }}>
                            <Select.Option value="Standard Scaler">Standard Scaler</Select.Option>
                            <Select.Option value="MinMax Scaler">MinMax Scaler</Select.Option>
                            <Select.Option value="Normalization"> Normalization</Select.Option>
                          </Select>
                        </Form.Item>
                        <MinusCircleOutlined onClick={() => remove(name)} />
                      </Space>
                    ))}
                    <Form.Item>
                      <Button
                        type="dashed"
                        style={{ width: '500px' }}
                        onClick={() => add()}
                        block
                        icon={<PlusOutlined />}
                      >
                        Add Transformations
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List>
            </Form>
          </div>
        ),
      }
    ];

    let items = [
      {
        key: 'DataSet',
        label: translation('Data Set'),
        children: (
          <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '40px' }}>
            <Form.Item
              label={translation('DataSource')}
              name="DataSourceID"
              style={formItemLayout}
              rules={[
                {
                  required: true,
                  message: 'Please Select DataSource'
                }
              ]}
            >
              <Select
                style={{ width: '70%' }}
                placeholder={translation('Please Select DataSource')}
              >
                {dataSourceList &&
                  Array.isArray(dataSourceList) &&
                  dataSourceList.map((item, index) => {
                    return (
                      <Select.Option key={index} value={item.Id}>
                        {item.Name}
                      </Select.Option>
                    );
                  })}
              </Select>
            </Form.Item>
            <Form.Item
              label={translation('Device')}
              name="Devices"
              rules={[{ required: true }]}
              style={formItemLayout}
            >
              <Select
                mode="multiple"
                maxTagCount={'responsive'}
                placeholder={translation('Please Select Device')}
                style={{ width: '70%' }}
                onChange={(value) => onCheck('Devices', value)}
              >
                {deviceList &&
                  Array.isArray(deviceList) &&
                  deviceList.map((tag) => {
                    return (
                      <Select.Option value={tag.key} key={tag.key}>
                        {translation(tag.key)}
                      </Select.Option>
                    );
                  })}{' '}
              </Select>
            </Form.Item>
            <Form.Item
              label={translation('Tags')}
              name="Tags"
              rules={[{ required: true }]}
              style={formItemLayout}
            >
              <Select
                maxTagCount="responsive"
                mode="multiple"
                style={{ width: '70%' }}
                placeholder={translation('Please Select Tags')}
                options={parameterList}
                onChange={(key, value) => tagChange(key, value)}
              />
              {/* {parameterList &&
                Array.isArray(parameterList) &&
                parameterList.map((tag) => {
                  return (
                    <Select.Option value={tag.value} key={tag.key}>
                      {this.translation(tag.value)}-{this.translation(tag.Description)}
                    </Select.Option>
                  );
                })}{' '}
            </Select> */}
            </Form.Item>
            <Form.Item
              label=" Train From And To Date"
              name={'TrainDate'}
              style={formItemLayout}
            // rules={[
            //   {
            //     required: true,
            //     message: 'Please Select From And To Date'
            //   }
            // ]}
            >
              <RangePicker
                style={{ width: '70%' }}
                showTime={{ format: 'HH:mm' }}
                format="YYYY-MM-DD HH:mm"
                placeholder={['Start DateTime', 'End DateTime']}
                value={momentRange1}
                onChange={onChangeTrainDate}
                // onOk={this.onhandleRangepicker}
                disabledDate={disabledDate}
              />
            </Form.Item>
            <Form.Item
              label=" Validation From And To Date"
              name={'ValidationDate'}
              style={formItemLayout}
            // rules={[
            //   {
            //     required: true,
            //     message: 'Please Select From And To Date'
            //   }
            // ]}
            >
              <RangePicker
                style={{ width: '70%' }}
                showTime={{ format: 'HH:mm' }}
                format="YYYY-MM-DD HH:mm"
                placeholder={['Start DateTime', 'End DateTime']}
                value={momentRange2}
                onChange={onChangeValidationDate}
                // onOk={onhandleRangepicker}
                disabledDate={disabledDate}
              />
            </Form.Item>
            <Form.Item
              label="Test From And To Date"
              name={'TestDate'}
              style={formItemLayout}
            // rules={[
            //   {
            //     required: true,
            //     message: 'Please Select From And To Date'
            //   }
            // ]}
            >
              <RangePicker
                style={{ width: '70%' }}
                showTime={{ format: 'HH:mm' }}
                format="YYYY-MM-DD HH:mm"
                placeholder={['Start DateTime', 'End DateTime']}
                value={momentRange3}
                onChange={onChangeTestDate}
                // onOk={this.onhandleRangepicker}
                disabledDate={disabledDate}
              />
            </Form.Item>
          </div>
        ),
      },
      {
        key: 'Preprocessing',
        label: translation('Pre Processing'),
        children: (
          <div
            style={{ display: 'flex', flexWrap: 'wrap', marginTop: '40px' }}
            theme={themeSettings}
          >
            <Collapse
              // activeKey={this.state.openPanels}
              defaultActiveKey={['1', '2', '3']}
              style={{ width: '1500px' }}
              expandIcon={({ isActive }) =>
                isActive ? <MinusCircleOutlined /> : <PlusOutlined />
              }
              // onChange={this.onCollapseChange}
              items={preprocessingItems}
            />
          </div>
        ),
      },
      {
        key: 'Algorithm',
        label: translation('Algorithm'),
        children: (
          <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '40px' }}>
            <Form.Item name="AlgorithmId" label="Algorithm Name" style={formItemLayout}>
              <Select
                style={{ width: '70%' }}
                placeholder={translation('Please Select Algorithm Name')}
                onChange={algorithmChange}
              >
                {algorithmList &&
                  Array.isArray(algorithmList) &&
                  algorithmList.map((Algorithm) => {
                    return (
                      <Select.Option value={Algorithm.Id} key={Algorithm.Id}>
                        {Algorithm.AlgorithmName}
                      </Select.Option>
                    );
                  })}{' '}
              </Select>
            </Form.Item>
            {/* <Form.Item
            name="HyperParameters"
            label="Hyper Parameters"
            style={formItemLayout}
          >
            <Select
              mode="multiple"
              maxTagCount={'responsive'}
              style={{ width: '70%' }}
              placeholder={this.translation('Please Select Hyper Parameter')}
            >
              {HyperParameterList &&
                Array.isArray(HyperParameterList) &&
                HyperParameterList.map((Parameter) => {
                  return (
                    <Select.Option value={Parameter.Name} key={Parameter.Name}>
                      {Parameter.Name}
                    </Select.Option>
                  );
                })}{' '}
            </Select>
          </Form.Item> */}
            <Form.Item
              label={translation('Hyper Parameters')}
              name="HyperParameters"
              style={formItemLayout}
            >
              <Button
                type="dashed"
                  onClick={() => {
                setParametersData({ users: hyperParametersData });
                dynamicFormRef?.setFieldsValue({ users: hyperParametersData });
                setParameterModal(true);
              }}

              >
                {'...'}
              </Button>
            </Form.Item>
            <Modal
              open={parameterModal}
              theme={themeSettings}
              width={800}
              closable
              title={
                formObject &&
                  formObject.AlgorithmData &&
                  formObject.AlgorithmData[0] &&
                  formObject.AlgorithmData[0].HyperParameters !== null
                  ? 'Update Hyper Parameters'
                  : 'Add Hyper Parameters'
              }
              onCancel={() => setParameterModal(false)}
              footer={null}
            >
              <Form
                name="dynamic_form_nest_item_parameter"
                onFinish={onSubmit}
                autoComplete="off"
                form={dynamicFormRef}
                initialValues={parametersData ? parametersData : {}}
              // style={{ paddingLeft: '10%' }}
              >
                <Form.List name="users">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }) => (
                        <Space
                          key={key}
                          style={{
                            display: 'flex',
                            marginBottom: 8
                          }}
                          align="baseline"
                        >
                          <Form.Item
                            {...restField}
                            name={[name, 'Name']}
                            rules={[
                              {
                                required: true,
                                message: 'Missing Name'
                              }
                            ]}
                          >
                            <Input placeholder=" Name" />
                          </Form.Item>
                          <Form.Item
                            {...restField}
                            name={[name, 'DefaultValue']}
                            rules={[
                              {
                                required: true,
                                message: 'Missing Default Value'
                              }
                            ]}
                          >
                            <Input placeholder="Default Value" />
                          </Form.Item>
                          <MinusCircleOutlined onClick={() => remove(name)} />
                        </Space>
                      ))}
                      <Form.Item>
                        <Button
                          type="dashed"
                          style={{ width: '70%' }}
                          onClick={() => add()}
                          block
                          icon={<PlusOutlined />}
                        >
                          Add Parameter
                        </Button>
                      </Form.Item>
                    </>
                  )}
                </Form.List>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'right',
                    paddingLeft: '10px'
                  }}
                >
                  <Form.Item>
                    <Button type="primary" style={{ marginRight: 8, }} htmlType="submit">
                      Submit
                    </Button>
                  </Form.Item>
                  <Form.Item>
                    <Button
                      key={'back'}
                      style={{ marginRight: 8 }}
                      onClick={() => setParameterModal(false)}
                    >
                      Cancel
                    </Button>
                  </Form.Item>
                </div>
              </Form>
            </Modal>
            <Form.Item
              label={translation('Model Type')}
              name="ModelType"
              rules={[{ required: true }]}
              style={formItemLayout}
            >
              <Select
                style={{ width: '70%' }}
                onChange={onModelTypeChange}
                placeholder={translation('Please Select Model Type')}
              >
                {modelTypeList &&
                  Array.isArray(modelTypeList) &&
                  modelTypeList.map((Model) => {
                    return (
                      <Select.Option value={Model.key} key={Model.key}>
                        {Model.value}
                      </Select.Option>
                    );
                  })}{' '}
              </Select>
            </Form.Item>

            <Form.Item
              label={translation('Applicable metrics')}
              name="Metrics"
              rules={[{ required: true }]}
              style={formItemLayout}
            >
              <Select
                mode="multiple"
                maxTagCount={'responsive'}
                style={{ width: '70%' }}
                disabled={selectedModelType ? false : true}
                placeholder={translation('Please Select Applicable Metrics')}
              >
                {applicableMetricsList &&
                  Array.isArray(applicableMetricsList) &&
                  applicableMetricsList.map((metrics) => {
                    return (
                      <Select.Option value={metrics.value} key={metrics.key}>
                        {metrics.key}
                      </Select.Option>
                    );
                  })}{' '}
              </Select>
            </Form.Item>
          </div>
        ),
      },
      {
        key: 'Labelling Critieria',
        label: translation('Labeling Critieria'),
        children: (
          <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '40px' }}>
            <Form.Item
              label={translation('Device')}
              name="TargetDevices"
              rules={[{ required: true }]}
              style={formItemLayout}
            >
              <Select
                // mode="multiple"
                // maxTagCount={'responsive'}
                placeholder={translation('Please Select Target Device')}
                style={{ width: '70%' }}
                onChange={(value) => onCheckDevice('TargetDevices', value)}
              >
                {deviceList &&
                  Array.isArray(deviceList) &&
                  deviceList.map((tag) => {
                    return (
                      <Select.Option value={tag.key} key={tag.key}>
                        {translation(tag.key)}
                      </Select.Option>
                    );
                  })}{' '}
              </Select>
            </Form.Item>
            <Form.Item
              label={translation('Target Parameters')}
              name="TargetParameter"
              rules={[{ required: true }]}
              style={formItemLayout}
            >
              <Select
                // maxTagCount={'responsive'}
                // mode="multiple"
                style={{ width: '70%' }}
                placeholder={translation('Please Select Tags')}
                options={labelParameterList}
              />
            </Form.Item>
            <Form.Item name="Aggregation" label="Aggregation" style={formItemLayout}>
              <Select style={{ width: '70%' }}>
                <Select.Option value={'Min'}>Min</Select.Option>
                <Select.Option value={'Max'}>Max</Select.Option>
                <Select.Option value={'Avg'}>Avg</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item
              label={translation('Target From And To')}
              name="FuturePeriodFrom"
              rules={[{ required: true }]}
              style={formItemLayout}
            >
              <Input.Group compact>
                <Form.Item name="FuturePeriodFrom">
                  <Input
                    type="number"
                    onKeyDown={(e) => {
                      if ([8].includes(e.keyCode)) {
                        return;
                      }
                      if (
                        (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
                        (e.keyCode < 96 || e.keyCode > 105)
                      ) {
                        e.preventDefault();
                      }
                    }}
                    style={{ textAlign: 'center', width: 65 }}
                  />
                </Form.Item>
                <Form.Item rules={[{ required: true }]}>
                  <Input
                    style={{
                      width: 50,
                      borderLeft: 0,
                      borderRight: 0,
                      pointerEvents: 'none'
                    }}
                    placeholder={translation('To')}
                    disabled
                  />
                </Form.Item>
                <Form.Item name="FuturePeriodTo">
                  <Input
                    type="number"
                    onKeyDown={(e) => {
                      if ([8].includes(e.keyCode)) {
                        return;
                      }
                      if (
                        (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
                        (e.keyCode < 96 || e.keyCode > 105)
                      ) {
                        e.preventDefault();
                      }
                    }}
                    style={{
                      textAlign: 'center',
                      borderLeft: 0,
                      width: 70
                    }}
                  // disabled
                  />
                </Form.Item>
                <Form.Item rules={[{ required: true }]}>
                  <Input
                    style={{
                      width: 90,
                      borderLeft: 0,
                      borderRight: 0,
                      pointerEvents: 'none'
                    }}
                    placeholder={translation('UOM')}
                    disabled
                  />
                </Form.Item>
                <Form.Item name="FuturePeriodUom">
                  <Select style={{ width: 120 }}>
                    {futurePeriodUomList &&
                      Array.isArray(futurePeriodUomList) &&
                      futurePeriodUomList.map((item) => {
                        return (
                          <Option value={item.key} key={item.key}>
                            {item.key}
                          </Option>
                        );
                      })}{' '}
                  </Select>
                </Form.Item>
              </Input.Group>
            </Form.Item>
            {selectedModelType && selectedModelType === 'Classification' ? (
              <StyledBox>
                <StyledBoxLabel>
                  {translation('Classification Target')}
                </StyledBoxLabel>
                <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '50px' }}>
                  <Form
                    name="dynamic_form_nest_item"
                    // onFinish={this.onClassificationSubmit}
                    autoComplete="off"
                    form={ClassificationRef}
                    initialValues={classification}
                    style={{ paddingLeft: '5%' }}
                  >
                    <Form.List name="Classification">
                      {(fields, { add, remove }) => (
                        <>
                          {fields.map(({ key, name, ...restField }) => (
                            <Space
                              key={key}
                              style={{
                                display: 'flex',
                                marginBottom: 8
                              }}
                              align="baseline"
                            >
                              <Form.Item
                                {...restField}
                                name={[name, 'Condition']}
                                rules={[
                                  {
                                    required: true,
                                    message: 'Missing Condition'
                                  }
                                ]}
                              >
                                <Select
                                  placeholder=" Condition"
                                  style={{ width: '200px' }}
                                >
                                  {Operator.map((item, index) => {
                                    return (
                                      <>
                                        <Select.Option key={index} value={item.value}>
                                          {item.value}
                                        </Select.Option>
                                      </>
                                    );
                                  })}
                                </Select>
                              </Form.Item>
                              <Form.Item
                                {...restField}
                                name={[name, 'Value']}
                                rules={[
                                  {
                                    required: true,
                                    message: 'Missing Value'
                                  }
                                ]}
                              >
                                <Input
                                  type="number"
                                  onKeyDown={(e) => {
                                    if ([8].includes(e.keyCode)) {
                                      return;
                                    }
                                    if (
                                      (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
                                      (e.keyCode < 96 || e.keyCode > 105)
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                  style={{ width: '200px' }}
                                  placeholder=" Value"
                                // onChange={this.onChangeValue1}
                                />
                              </Form.Item>
                              <Form.Item
                                {...restField}
                                name={[name, 'Class']}
                                rules={[
                                  {
                                    required: true,
                                    message: 'Missing Class'
                                  }
                                ]}
                              >
                                <Select
                                  value={selectedItems}
                                  onChange={classOnChange}
                                  placeholder=" Class"
                                  style={{ width: '200px' }}
                                >
                                  {filteredOptions.map((item) => (
                                    <Select.Option key={item} value={item}>
                                      {item}
                                    </Select.Option>
                                  ))}
                                </Select>
                              </Form.Item>
                              <Form.Item
                                {...restField}
                                name={[name, 'label']}
                                rules={[
                                  {
                                    required: true,
                                    message: 'Missing label'
                                  }
                                ]}
                              >
                                <Input placeholder=" label" style={{ width: '200px' }} />
                              </Form.Item>
                              <MinusCircleOutlined onClick={() => remove(name)} />
                            </Space>
                          ))}
                          <Form.Item style={{ paddingLeft: '20%' }}>
                            <Button
                              type="dashed"
                              style={{ width: '250px' }}
                              onClick={
                                () => {
                                  if (fields && fields.length < 2) {
                                    add();
                                  } else {
                                    message.warning('You Can add Only Two conditions');
                                  }
                                }
                                //  add()
                              }
                              block
                              icon={<PlusOutlined />}
                            >
                              Add Classification Target
                            </Button>
                          </Form.Item>
                        </>
                      )}
                    </Form.List>
                  </Form>
                </div>
              </StyledBox>
            ) : null}
          </div>
        ),
      },
      {
        key: 'Models',
        label: translation('Models'),
        children: (
          <div style={{ marginTop: '40px' }}>
            <StyledTable
              columns={ModelsColumns}
              dataSource={modelsDataSource}
            />
          </div>
        ),
      }
    ];
    return (
      <>
        <div
          style={{
            margin: '10px',
          }}
        >
          <Breadcrumb
            style={{
              padding: '20px 0px 10px 35px',
              color: 'white',
              fontWeight: '800',
              fontSize: '16px'
            }}
            separator=">"
            className="_Bredacrumb_"
          >
            {breadcrumbList &&
              Array.isArray(breadcrumbList) &&
              breadcrumbList.map((breadcrumb, index) => {
                if (
                  breadcrumb &&
                  breadcrumb.type &&
                  breadcrumb.type === 'home' &&
                  breadcrumbList.length === 1
                ) {
                  return (
                    <Breadcrumb.Item key={{ index }}>
                      <Link
                        to={`/rubus/RubusAnalytics/${breadcrumb.type}`}
                        onClick={(e) => changeOnBreadCrumb(breadcrumbList, e, index)}
                      >
                        {''}
                      </Link>
                    </Breadcrumb.Item>
                  );
                } else if (breadcrumb && breadcrumb.type && breadcrumb.type === 'home') {
                  return (
                    <Breadcrumb.Item key={{ index }}>
                      <Link
                        to={`/rubus/RubusAnalytics/${breadcrumb.type}`}
                        onClick={(e) => changeOnBreadCrumb(breadcrumbList, e, index)}
                      >
                        {breadcrumb.title}
                      </Link>
                    </Breadcrumb.Item>
                  );
                } else if ((breadcrumb.type === 'Prediction' || breadcrumb.type === 'Analysis') &&
                  (breadcrumb && breadcrumb.Id)) {
                  return (
                    <Breadcrumb.Item key={{ index }}>
                      <Link
                        to={`/rubus/RubusAnalytics/Tasks/${breadcrumb.Id}?AnalyticsId=${analyticsId}&Type=${type}`}
                        onClick={(e) => changeOnBreadCrumb(breadcrumbList, e, index)}
                      >
                        {breadcrumb.title}
                      </Link>
                    </Breadcrumb.Item>
                  );
                } else if (breadcrumb && breadcrumb.Id) {
                  return (
                    <Breadcrumb.Item key={{ index }}>
                      <Link
                        to={`/rubus/RubusAnalytics/${breadcrumb.type}/${breadcrumb.Id}`}
                        onClick={(e) => changeOnBreadCrumb(breadcrumbList, e, index)}
                      >
                        {breadcrumb.title}
                      </Link>
                    </Breadcrumb.Item>
                  );
                } else {
                  return (
                    <Breadcrumb.Item key={{ index }}>
                      <Link
                        to={`/rubus/RubusAnalytics/${breadcrumb.type}/New`}
                        onClick={(e) => changeOnBreadCrumb(breadcrumbList, e, index)}
                      >
                        {breadcrumb.title}
                      </Link>
                    </Breadcrumb.Item>
                  );
                }

              })}
          </Breadcrumb>
          <>
            <Form
              name="Training Jobs"
              theme={themeSettings}
              form={mainFormRef}
              onFinish={FormSubmit}
              onKeyDown={(e) => {
                e.key === 'Enter' && e.preventDefault();
              }}
              initialValues={formObject || {}}
              layout="horizontal"
              labelCol={{ flex: '200px' }}
              labelAlign="right"
              labelWrap
              // wrapperCol={{ flex: 1 }}
            // validateMessages={validateMessages}
            >
              <div style={{ display: 'flex', justifyContent: 'right' }}>
                <Form.Item>
                  <Button type="primary" onClick={FormSave} style={{ marginRight: '8px' }}>
                    Save
                  </Button>
                </Form.Item>
                <Form.Item>
                  <Button
                    type="primary"
                    onClick={FormSubmit}
                    disabled={
                      payload === undefined ||
                        (payload && payload !== undefined && Object.keys(payload).length === 0)
                        ? true
                        : false
                    }
                  >
                    Submit
                  </Button>
                </Form.Item>
              </div>

              <div style={{ marginTop: '24px', display: 'flex', flexWrap: 'wrap' }}>
                <Form.Item
                  label="Name"
                  name={'Name'}
                  style={formItemLayout}
                  rules={[
                    {
                      required: true,
                      message: 'Please Provide Name'
                    }
                  ]}
                >
                  <Input
                    maxLength={10000}
                    size="large"
                    style={{ width: '70%' }}
                    placeholder="Input Training Job Name"
                  />
                </Form.Item>
                <Form.Item
                  // labelCol={{ flex: '200px' }}
                  // {...restField}
                  name={'Description'}
                  label="Description"
                  style={formItemLayout}
                  rules={[
                    {
                      required: true,
                      message: 'Please Provide Description'
                    }
                  ]}
                >
                  <Input
                    maxLength={10000}
                    size="large"
                    style={{ width: '70%' }}
                    placeholder="Input Description"
                  />
                </Form.Item>

                <Form.Item
                  label="Status"
                  name={'Status'}
                  placeholder="Select Status"
                  style={formItemLayout}
                >
                  <Select
                    placeholder="Search Status"
                    style={{ width: '70%'}}
                    disabled={formObject && formObject.Status ? false : true}
                  >
                    {/* {StatusList &&
                      Array.isArray(StatusList) &&
                      StatusList.map((item, index) => {
                        return ( */}
                    <Select.Option value={'Cancelled'}>Cancelled</Select.Option>
                    {/* );
                      })} */}
                  </Select>
                </Form.Item>

                <Form.Item label="Training Server" name={'TrainingServerId'} style={formItemLayout}>
                  <Select placeholder="Please Select Training Server" style={{ width: '70%' }}>
                    {trainingServerList &&
                      Array.isArray(trainingServerList) &&
                      trainingServerList.map((item, index) => {
                        return (
                          <Select.Option key={index} value={item.Id}>
                            {item.Name}
                          </Select.Option>
                        );
                      })}
                  </Select>
                </Form.Item>
                <Form.Item style={formItemLayout} label="Created By" name={'CreatedBy'}>
                  <Select
                    disabled
                    value={
                      props &&
                      props.userProfile &&
                      props.userProfile.user &&
                      props.userProfile.user.Id
                    }
                    suffix={<UserOutlined />}
                    size="large"
                    placeholder="Select CreatedBy"
                    style={{ width: '70%'}}
                  >
                    {users &&
                      Array.isArray(users) &&
                      users.map((item, index) => {
                        return (
                          <Select.Option key={index} value={item.Id}>
                            {item.FirstName}
                          </Select.Option>
                        );
                      })}
                  </Select>
                </Form.Item>

                <Form.Item style={formItemLayout} label="Created Date" name={'CreatedDate'}>
                  <Input
                    disabled
                    size="large"
                    style={{ width: '70%'}}
                    placeholder="CreatedDate"
                    suffix={<FieldTimeOutlined />}
                  />
                </Form.Item>
              </div>

              <div theme={themeSettings}>
                <Tabs
                  type="card"
                  style={{ color: 'black' }}
                  onChange={() => {
                    const pager = { ...pagination };
                    pager.current = 1;
                    setPagnition(pager);
                  }}
                  items={items}
                />
              </div>
            </Form>
          </>
        </div>
      </>
    );
  };


const mapStateToProps = (state) => {
  return {
    userProfile: state.LayoutReducer.loggedInProfile,
    translationCache: state.TranslationReducer.translationCache
  };
};

export default connect(mapStateToProps)(TrainingJobs);
